import { useEffect, useState } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { FormControl, Grid } from "@/comn/components";
import { comnUtils } from "@/comn/utils";
import { Page, Group, Layout, Button } from "@/comn/components"; // 화면 구성 컴포넌트
import { useForm, useFetch, useResource, useGrid, useModal, useToast, useAuth, usePage, usePopup } from "@/comn/hooks"; // hook
import {
    URLS,
    APIS,
    SF_BLL_CNCL_DTL_SRCH,
    SF_BLL_CNCL_DTL,
    SG_BLL_CNCL_DTL_BLL_LIST,
    SG_BLL_CNCL_DTL_LIST,
    SG_BLL_ITM_LIST,
} from "./services/OsciBllCnclService"; // 서비스
import { APIS_COMN, SF_COMN_TANSAD_INFO } from "@/tz/go/egaz/osci/colt/comn/OsciColtComnService"; // 공통 서비스
import { colEnvs, colUtils } from "@/tz/go/egaz/osci/colt/comn";
import { SF_APRV_RQST } from "@/comn/comn/aprv/service/AprvService";
import { OgaAprvRqst } from "@/comn/comn/aprv/OgaAprvRqst";

/*
 * Bill Cancellation Detail
 * !== 고지 취소 상세 ==!
 */
export const OSCI0403002Q = (props: any) => {
    /*
     * Declaration Hook, Meta
     * !== Hook, 메타 정보 정의 ==!
     */
    useResource({
        defaultSchema: [
            { area: "coCd" },
            { area: "comnCd", comnCd: "OSC0056" },
            { area: "comnCd", comnCd: "OSC0057" },
            { area: "comnCd", comnCd: "OSC0058" },
            { area: "comnCd", comnCd: "OSC0067" },
            { area: "comnCd", comnCd: "OSC0072" },
            { area: "comnCd", comnCd: "OSC0018" },
            { area: "comnCd", comnCd: "OSC0020" },
            { area: "comnCd", comnCd: "OSC0023" },
        ],
    });

    const { pgeUid, menuId } = usePage({
        auth: ["auth_osci0003", "auth_osci0021"],
    }); // Page Unique identifier !== 화면 고유 식별자 ==!
    const { t } = useTranslation(); // Translation Hook !== 언어 변환 Hook ==!
    const navigate = useNavigate(); // Navigate Hook !== 화면 이동 Hook ==!
    const modal = useModal(); // Modal Window Hook !== Modal 창 Hook ==!
    const popup = usePopup(); // Popup Hook !== Popup Hook ==!
    const toast = useToast(); // Toast Message Hook !== Toast 메세지 표시 Hook ==!
    const auth = useAuth(); // Login , User Information Hook !== 로그인, 유저정보 Hook ==!
    const { bllMgmtId } = useParams();
    const { aprvYn } = useParams();
    const [searchParams] = useSearchParams();
    const cnclRqstSn = searchParams.get("cnclRqstSn") || undefined;
    const getEffectiveCnclRqstSn = () => cnclRqstSn || form.bllCnclDtl.getValue("cnclRqstSn") || undefined;
    const getEffectiveBllMgmtId = () => form.bllCnclDtl.getValue("bllMgmtId") || bllMgmtId;

    // 폼 처리
    const [isReffTansad, setIsReffTansad] = useState(false);
    const [isXtns, setXtns] = useState(false);

    const [vsdDtls, setVsdDtls] = useState(false);
    const [vsdItms, setVsdItms] = useState(false);

    const [bllDtlList, setBllDtlList] = useState(comnUtils.getGridData([]));
    const [bllItmList, setBllItmList] = useState(comnUtils.getGridData([]));

    // 버튼 처리
    const [isVisibleBtn, setIsVisibleBtn] = useState(false);

    useResource({
        defaultSchema: [{ area: "comnCd", comnCd: "OSC0096" }],
    });

    /*
     * Declaration Form
     * !== 폼 정의 ==!
     */
    const form = {
        // Bill Cancellation Detail Search !== 고지 취소 상세 조회 ==!
        bllCnclDtlSrch: useForm({
            defaultSchema: SF_BLL_CNCL_DTL_SRCH,
            defaultValues: {
                bllMgmtId: bllMgmtId,
            },
        }),

        // Bill Cancellation Detail  !== 고지 취소 상세 폼 ==!
        bllCnclDtl: useForm({
            defaultSchema: SF_BLL_CNCL_DTL,
        }),
        // Common TANSAD Info  !== 공통 TANSAD정보 폼 ==!
        comnTansadInfo: useForm({
            defaultSchema: SF_COMN_TANSAD_INFO,
        }),

        aprvRqstForm: useForm({
            defaultSchema: SF_APRV_RQST,
            defaultValues: {
                ptlTpCd: "O", // 포털 구분 코드 (I: 내부, O: 외부)
                bsopClsfCd: "COL", // 업무 구분 코드
                scrnDocCd: "scrn_colt0010", // 문서 ID
                aprvReffId: "/" + bllMgmtId + "/Y", // 결재 요청 문서 Key 값
                aprvAfPrcssCfgnId: "cfgn_col0019", // 결재완료 후처리 ID (결재후처리설정 테이블에 등록된 후처리ID)
                rtrnAfPrcssCfgnId: "cfgn_col0020", // 반려 후처리 ID (결재후처리설정 테이블에 등록된 후처리ID)
                prevStageRtrnUseYn: "Y", // 이전단계 반려처리가 필요한 경우에만 'Y'로 넘겨 줄 것 (결재처리 시 이전단계반려 라디오버튼을 보여줌)
                itsfAprvYn: "N", // 업무팀 자체 결재처리 시 'Y'로 넘겨 줄 것 (결재처리탭 비활성화)
            },
        }),
    };

    const readyFunc = {
        readyBtn: (data: any) => {
            // const lgnAuthLst = auth.get("authList");
            // const lgnUsrCstmCd = auth.get("cstmCd");
            // const bllSysmCd = data?.bllSysmCd;
            // const aprvPrcssStatCd = data?.aprvPrcssStatCd;
            // const dspoYn = data?.dspoYn;
            // const tansadCncltnYn = data?.tansadCncltnYn;
            //
            // if ("Y" != dspoYn && "Y" != tansadCncltnYn) {
            // if (aprvPrcssStatCd != "A01" && aprvPrcssStatCd != "A03") {
            // if (lgnAuthLst.includes("auth_coli0001")) {
            // setIsVisibleBtn(true);
            // } else if (
            //     (lgnAuthLst.includes("auth_coli0013") || lgnAuthLst.includes("auth_osci0019")) &&
            //     lgnUsrCstmCd == bllSysmCd
            // ) {
            // setIsVisibleBtn(true);
            // }
            //     }
            // }
            setIsVisibleBtn(false);

            if (data?.xtnsDd) {
                setXtns(true);
            }

            if (data?.cnclStatCd && data.cnclStatCd === "R") {
                setIsVisibleBtn(true);
            }
        },
    };

    /*
     * Declaration Grid
     * !== 그리드 정의 ==!
     */
    const grid = {
        // Bill Detail List !== 고지 상세 목록 ==!
        bllDtlList: useGrid({
            defaultSchema: SG_BLL_CNCL_DTL_LIST,
        }),
        bllItmList: useGrid({
            defaultSchema: SG_BLL_ITM_LIST,
        }),
    };

    /*
     * Declaration Fetch
     * !== Fetch 정의 ==!
     */
    const fetch = {
        // Get Bill Cancellation Detail !== 고지 취소 상세 조회 ==!
        getBllCnclDtl: useFetch({
            api: () => APIS.getBllCnclDtl({ ...form.bllCnclDtlSrch.getValues(), cnclRqstSn }),
            enabled: !!bllMgmtId,
            onSuccess: (data) => {
                const bllCnclData = data.bllCnclDtl.content;

                if (!bllCnclData?.bllNo) {
                    form.bllCnclDtl.reset();
                    form.comnTansadInfo.reset();
                    modal.openModal({
                        content: "msg.osc.00182", // Please check Bill No.
                    });
                    return;
                }

                // form 데이터 세팅
                form.bllCnclDtl.setValues({
                    ...bllCnclData,
                });
                // form 데이터 세팅
                form.bllCnclDtlSrch.setValues({
                    ...bllCnclData,
                });

                // 버튼 컨트롤
                readyFunc.readyBtn(data.bllCnclDtl?.content);

                if (bllCnclData?.reffKeyTpCd) {
                    let reffKeyNo = bllCnclData?.reffKeyNo1;
                    if (bllCnclData?.reffKeyNo2 != null) {
                        reffKeyNo = reffKeyNo + "-" + bllCnclData?.reffKeyNo2;
                    }
                    if (bllCnclData?.reffKeyNo3 != null) {
                        reffKeyNo = reffKeyNo + "-" + bllCnclData?.reffKeyNo3;
                    }
                    if (bllCnclData?.reffKeyNo4 != null) {
                        reffKeyNo = reffKeyNo + "-" + bllCnclData?.reffKeyNo4;
                    }
                    // Reference Key
                    form.bllCnclDtl.setValue("reffKey", reffKeyNo);

                    if (bllCnclData?.reffKeyTpCd == "T") {
                        const tansadNo =
                            bllCnclData?.reffKeyNo1 + "-" + bllCnclData?.reffKeyNo2 + "-" + bllCnclData?.reffKeyNo3;
                        fetch.getTansadDtl.fetch(tansadNo);
                        setIsReffTansad(true);
                    }
                }

                if (data.bllCnclDtl.content.bllTpCd && data.bllCnclDtl.content.bllTpCd === "G") setVsdDtls(true);
                if (data.bllCnclDtl.content.bllDtls) {
                    setBllDtlList(comnUtils.getGridData(data.bllCnclDtl.content.bllDtls));
                }
                if (data.bllCnclDtl.content.bllItms && data.bllCnclDtl.content.bllItms.length > 0) {
                    setVsdItms(true);
                    setBllItmList(comnUtils.getGridData(data.bllCnclDtl.content.bllItms));
                }

                // 첨부파일
                const bsopId =
                    "COL|K|" +
                    bllCnclData.bllTpCd +
                    "|" +
                    bllCnclData.bllSysmCd +
                    "|" +
                    bllCnclData.bllYy +
                    "|" +
                    bllCnclData.bllSrno +
                    "|" +
                    bllCnclData.bllDgr;

                form.bllCnclDtl.setValue("fileSaveDto", bsopId);
                form.bllCnclDtl.setValue("bsopId", bsopId);
            },
            onError: () => {},
            showToast: true,
        }),
        // Get TANSAD Detail !== TANSAD 상세 조회 ==!
        getTansadDtl: useFetch({
            api: (tansadNo) => APIS_COMN.getTansad(tansadNo),
            onSuccess: (data) => {
                const tansadData = data.tansadInfo.content;

                if (!tansadData?.tansadNo) {
                    form.bllCnclDtl.reset();
                    form.comnTansadInfo.reset();

                    modal.openModal({
                        content: "msg.osc.00146", // Please check TANSAD No.
                    });
                    return;
                }

                const exppnImppnTinNm =
                    colUtils.setMask(tansadData.exppnImppnTin, "tin") + "(" + tansadData.exppnImppnNm + ")";
                const dcltTinNm = colUtils.setMask(tansadData.dcltTin, "tin") + "(" + tansadData.dcltNm + ")";

                // form 데이터 세팅
                form.comnTansadInfo.setValues({
                    ...tansadData,
                    exppnImppnTinNm: exppnImppnTinNm,
                    dcltTinNm: dcltTinNm,
                });
            },
            onError: () => {},
            showToast: true,
        }),
        // Delete Bill Cancellation !== 고지 취소 삭제 ==!
        deleteBllCncl: useFetch({
            api: (bllMgmtId, cnclRqstSnArg) => APIS.deleteBllCncl(bllMgmtId, cnclRqstSnArg),
            onSuccess: () => {
                modal.openModal({
                    content: "msg.osc.00006", // 성공적으로 처리 되었습니다.
                    onConfirm: () => {
                        navigate(`${URLS.osci0403001q}`);
                    },
                    onCancel: () => {
                        navigate(`${URLS.osci0403001q}`);
                    },
                });
            },
            onError: (error) => {
                if (error.response.status === 400) {
                    console.log(error.response.data);
                }
                modal.openModal({
                    content: "msg.osc.00015", // 처리중 문제가 발생하였습니다.
                });
            },
        }),
        // Bill Cancellation Approval Request After !== 고지 취소 승인 결재 요청 후처리 ==!
        bllCnclAprvRqstAf: useFetch({
            api: (data) => APIS.bllCnclAprvRqstAf(data),
            onSuccess: (data) => {
                modal.openModal({
                    content: "msg.osc.00006",
                    onConfirm: () => {
                        navigate(URLS.osci0403001q);
                    },
                    onCancel: () => {
                        navigate(URLS.osci0403001q);
                    },
                });
            },
            onError: (data) => {},
            showToast: true,
        }),
        cnclBll: useFetch({
            api: (data) => {
                return APIS.cnclBll(data);
            },
            onSuccess: (data) => {
                modal.openModal({
                    content: "msg.osc.00006", //Processed successfully.
                    onClose: () => {
                        fetch.getBllCnclDtl.fetch();
                    },
                });
            },
            onError: (error) => {
                modal.openModal({
                    content: "msg.osc.00015", //An error occurred during processing.
                });
            },
        }),
        reissBll: useFetch({
            api: (data) => {
                return APIS.reissBll(data);
            },
            onSuccess: (data) => {
                modal.openModal({
                    content: "msg.osc.00006", //Processed successfully.
                    onClose: () => {
                        fetch.getBllCnclDtl.fetch();
                    },
                });
            },
            onError: (error) => {
                modal.openModal({
                    content: "msg.osc.00015", //An error occurred during processing.
                });
            },
        }),
    };

    /*
     * Declaration Event Handler
     * !== 이벤트 핸들러 정의 ==!
     */
    const handler = {
        // Get Processing History List !== 처리 이력 목록 조회 ==!
        getPrcsHistLst: () => {
            let tansadNo = form.comnTansadInfo.getValue("tansadNo");
            tansadNo = colUtils.setMask(tansadNo, "tansadNo");

            // Declaration 처리이력 (팝업)
            popup.openPopup({
                id: "tansadPrcsHistLstPpup",
                url: URLS.clri0801029q,
                params: tansadNo,
                size: "lg",
                callback: (data: any) => {
                    console.log(data);
                },
            });
        },
        // Go Update Form !== 수정 화면 이동 ==!
        goUpdateForm: () => {
            const effectiveBllMgmtId = getEffectiveBllMgmtId();
            const effectiveCnclRqstSn = getEffectiveCnclRqstSn();
            navigate(
                URLS.osci0403003s +
                    "/UPDATE" +
                    "/" +
                    effectiveBllMgmtId +
                    (effectiveCnclRqstSn ? `?cnclRqstSn=${effectiveCnclRqstSn}` : ""),
            );
        },
        // Delete Bill Cancellation !== 고지 취소 삭제 ==!
        deleteBllCncl: () => {
            form.bllCnclDtl.handleSubmit(
                (data) => {
                    modal.openModal({
                        content: t("msg.osc.00038", { "0": "Cancellation" }), // Do you want to remove Cancellation?
                        onConfirm: () => {
                            console.log(form.bllCnclDtl.getValues());
                            fetch.deleteBllCncl.fetch(getEffectiveBllMgmtId(), getEffectiveCnclRqstSn());
                        },
                    });
                },
                (data) => {
                    toast.showToast({ type: "warning", content: "msg.osc.00003" }); // 데이터가 유효하지 않습니다.
                },
            )();
        },
        // Click Apprvoal Request Button !== 결재 요청 버튼 클릭 ==!
        onAprvRqstBtnClick: () => {
            modal.openModal({
                // url: "/comn/comn/ppup/aprvRqstPpup",
                // params: {
                //     bsopClsfCd: "COL", //업무시스템 구분
                //     scrnDocCd: "scrn_colt0010", //화면문서코드테이블에 등록된 화면문서ID
                //     aprvReffId: "/" + bllNo + "/Y", //결재문서 조회를 위한 결재참고ID
                //     aprvAfPrcssCfgnId: "cfgn_col0019", // 결재 승인 후 처리 설정 테이블에 등록된 후처리ID
                //     rtrnAfPrcssCfgnId: "cfgn_col0020", // 결재 반려 후 처리 설정 테이블에 등록된 후처리ID
                // },
                // size: "md",
                // draggable: true,
                // callback: (data) => {
                //     // !== 결재완료 후 해당 callback 함수에 결재번호를 리턴해줌  ==!
                //     console.log("Check Data 결재아이디 >>>>> ", data.aprvId);
                //     modal.closeModal();

                //     const param = { ...form.bllCnclDtlSrch.getValues(), aprvId: data.aprvId };

                //     // // 결재상신 후 처리
                //     fetch.bllCnclAprvRqstAf.fetch(param);
                // },
                content: (
                    <OgaAprvRqst
                        paramData={{
                            bsopClsfCd: "COL", // 업무시스템 구분
                            scrnDocCd: "scrn_colt0010", // 화면문서코드테이블에 등록된 화면문서ID
                        }}
                        callbackFn={(aprvData: any) => {
                            if (aprvData) {
                                form.aprvRqstForm.setValues({
                                    aprvId: aprvData.aprvId,
                                    aprvRqstTtleNm: aprvData.aprvRqstTtleNm,
                                    aprvRqstCn: aprvData.aprvRqstCn,
                                    usrDmnId: aprvData.usrDmnId,
                                    aprvPrcssPathMgmtId: aprvData.aprvPrcssPathMgmtId,
                                });

                                const param = {
                                    ...form.bllCnclDtlSrch.getValues(),
                                    cnclRqstSn,
                                    aprvRqstDto: form.aprvRqstForm.getValues(),
                                };
                                console.log("callbackFn data", param);
                                fetch.bllCnclAprvRqstAf.fetch(param);
                            }
                            modal.closeModal("OgaAprvRqst");
                        }}
                    />
                ),
                size: "md",
                draggable: true,
                close: false,
                id: "OgaAprvRqst",
            });
        },
        cnclBill: form.bllCnclDtl.handleSubmit(
            () => {
                const data = { ...form.bllCnclDtl.getValues() };
                modal.openModal({
                    content: "msg.osc.00180", //Do you want to execute?
                    onConfirm: () => {
                        fetch.cnclBll.fetch(data);
                    },
                });
            },
            () => {
                toast.showToast({ type: "warning", content: "msg.osc.00003" });
            },
        ),
        reissBll: form.bllCnclDtl.handleSubmit(
            () => {
                const data = {
                    ...form.bllCnclDtl.getValues(),
                    ...form.comnTansadInfo.getValues(),
                    ...form.bllCnclDtlSrch.getValues(),
                };
                modal.openModal({
                    content: "msg.osc.00180", //Do you want to execute?
                    onConfirm: () => {
                        fetch.reissBll.fetch(data);
                    },
                });
            },
            () => {
                toast.showToast({ type: "warning", content: "msg.osc.00003" });
            },
        ),
    };

    const render = {
        grid_bllDtlList: {
            head: {},
            cell: {},
            edit: {},
        },
        grid_bllItmList: {
            head: {},
            cell: {},
            edit: {},
        },
    };
    /*
     * Declaration Page Init Function
     * !== 화면 초기화 함수 선언  ==!
     */
    useEffect(() => {
        form.bllCnclDtlSrch.setEditable(false);
        form.bllCnclDtl.setEditable(false);
        form.comnTansadInfo.setEditable(false);
    }, []);

    return (
        <Page>
            {/* 고지 취소 상세 조회 */}
            <Group>
                <Group.Body>
                    <Group.Section>
                        <Group.Row>
                            <Group.Control {...form.bllCnclDtlSrch.schema.bllNo} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Label {...form.bllCnclDtlSrch.schema.bllMgmtId}></Group.Label>
                            <Group.Col>
                                <Group.Control {...form.bllCnclDtlSrch.schema.bllTpCd} />
                                <Group.Any>-</Group.Any>
                                <Group.Control {...form.bllCnclDtlSrch.schema.bllSysmCd} />
                                <Group.Any>-</Group.Any>
                                <Group.Control {...form.bllCnclDtlSrch.schema.bllYy} />
                                <Group.Any>-</Group.Any>
                                <Group.Control {...form.bllCnclDtlSrch.schema.bllSrno} />
                                <Group.Any>-</Group.Any>
                                <Group.Control {...form.bllCnclDtlSrch.schema.bllDgr} />
                            </Group.Col>
                        </Group.Row>
                    </Group.Section>
                </Group.Body>
            </Group>
            {isReffTansad && (
                <>
                    {/* TANSAD */}
                    <Group>
                        <Group.Body>
                            <Group.Title title={"T_TANSAD_GNRL"} titleSize={2}></Group.Title>
                            <Group.Section>
                                <Group.Row>
                                    <Group.Control {...form.comnTansadInfo.schema.tansadNo} />
                                    <Group.Control {...form.comnTansadInfo.schema.tansadDt} />
                                </Group.Row>
                                <Group.Row>
                                    <Group.Control {...form.comnTansadInfo.schema.regm} />
                                    <Group.Control {...form.comnTansadInfo.schema.csclPlnCd} />
                                </Group.Row>
                                <Group.Row>
                                    <Group.Control {...form.comnTansadInfo.schema.exppnImppnTinNm} />
                                    <Group.Control {...form.comnTansadInfo.schema.dcltTinNm} />
                                </Group.Row>
                                <Group.Row>
                                    <Group.Control {...form.comnTansadInfo.schema.dclrPrcssSttsCd} />
                                </Group.Row>
                            </Group.Section>
                        </Group.Body>
                    </Group>
                </>
            )}
            {/* Bill */}
            <Group>
                <Group.Body>
                    <Group.Title title={"L_BLL_GNRL"} titleSize={2}></Group.Title>
                    <Group.Section>
                        <Group.Row>
                            <Group.Control {...form.bllCnclDtl.schema.bllNo} />
                            <Group.Control {...form.bllCnclDtl.schema.bllDt} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.bllCnclDtl.schema.ctrlNo} />
                            <Group.Control {...form.bllCnclDtl.schema.zmpDt} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.bllCnclDtl.schema.bllStatCd} />
                            <Group.Control {...form.bllCnclDtl.schema.bllRgsrId} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.bllCnclDtl.schema.pyerMgmtNo} />
                            <Group.Control {...form.bllCnclDtl.schema.payDdlnDt} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.bllCnclDtl.schema.reffKeyTpCd} />
                            <Group.Control {...form.bllCnclDtl.schema.reffKey} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.bllCnclDtl.schema.currCd} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.bllCnclDtl.schema.feeAmt} />
                            <Group.Control {...form.bllCnclDtl.schema.feeTzsAmt} />
                        </Group.Row>
                        {isXtns && (
                            <>
                                <Group.Row>
                                    <Group.Control {...form.bllCnclDtl.schema.lastDdlnXtnsDt} />
                                    <Group.Control {...form.bllCnclDtl.schema.xtnsDd} />
                                </Group.Row>
                                <Group.Row>
                                    <Group.Control {...form.bllCnclDtl.schema.lastDdlnXtnsRsn} />
                                </Group.Row>
                            </>
                        )}
                        <Group.Row>
                            <Group.Control {...form.bllCnclDtl.schema.dspoCd} />
                            <Group.Control {...form.bllCnclDtl.schema.dspoDt} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.bllCnclDtl.schema.dspoRmrk} />
                        </Group.Row>
                    </Group.Section>
                </Group.Body>
            </Group>

            {vsdDtls && (
                <Group>
                    <Group.Body>
                        {" "}
                        <Layout direction="row">
                            <Layout.Left>
                                <Group.Title title={"T_BLL_DTL_1"} titleSize={2}></Group.Title>
                            </Layout.Left>
                        </Layout>
                        <Grid {...grid.bllDtlList.grid} data={bllDtlList} render={render.grid_bllDtlList} />
                    </Group.Body>
                </Group>
            )}
            {vsdItms && (
                <Group>
                    <Group.Body>
                        {" "}
                        <Layout direction="row">
                            <Layout.Left>
                                <Group.Title title={"T_ITM_LST"} titleSize={2}></Group.Title>
                            </Layout.Left>
                        </Layout>
                        <Grid {...grid.bllItmList.grid} data={bllItmList} render={render.grid_bllItmList} />
                    </Group.Body>
                </Group>
            )}
            {/* Cancellation */}
            <Group>
                <Group.Body>
                    <Group.Title title={"T_CNCLTN_DTL"} titleSize={2}></Group.Title>
                    <Group.Section>
                        <Group.Row>
                            <Group.Control {...form.bllCnclDtl.schema.dspoDt} />
                            <Group.Control {...form.bllCnclDtl.schema.cnclStatCd} />
                        </Group.Row>
                        {/* <Group.Row><Group.Control {...form.bllCnclDtl.schema.aprvPrcssStatCd} /></Group.Row> */}
                        <Group.Row>
                            <Group.Control {...form.bllCnclDtl.schema.dspoCd} />
                            <Group.Control {...form.bllCnclDtl.schema.dspoRmrk} />
                        </Group.Row>
                    </Group.Section>
                </Group.Body>
            </Group>
            {/* <Group>
                <Group.Body>
                    <Group.Title title={"L_ATCH_FILE"} titleSize={2}></Group.Title>
                    <Group.Section>
                        <FormControl {...form.bllCnclDtl.schema.fileSaveDto} />
                    </Group.Section>
                </Group.Body>
            </Group> */}
            {aprvYn != "Y" && (
                <Layout direction="row">
                    <Layout.Left>
                        <Button
                            role="list"
                            onClick={() => {
                                navigate(URLS.osci0403001q);
                            }}
                        ></Button>
                    </Layout.Left>
                    <Layout.Right>
                        {isVisibleBtn && (
                            <>
                                <Button
                                    onClick={() => {
                                        handler.cnclBill();
                                    }}
                                >
                                    {t("B_ZMP_SEND")}
                                </Button>
                                <Button
                                    onClick={() => {
                                        handler.goUpdateForm();
                                    }}
                                >
                                    {t("B_UPDT")}
                                </Button>
                                <Button
                                    role="delete"
                                    onClick={() => {
                                        handler.deleteBllCncl();
                                    }}
                                ></Button>
                                {/* <Button variant="primary" onClick={handler.onAprvRqstBtnClick}>
                                {t("B_APRV_RQST")}
                            </Button> */}
                            </>
                        )}
                        {process.env.NODE_ENV === "development" && (
                            <>
                                <Button
                                    onClick={() => {
                                        handler.reissBll();
                                    }}
                                >
                                    Reissue
                                </Button>
                            </>
                        )}
                    </Layout.Right>
                </Layout>
            )}
        </Page>
    );
};
